import React, { useState } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Home, Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';

function MobileBottomNav() {
    const [value, setValue] = useState(0);
    const navigate = useNavigate();

    const handleNavigation = (index) => {
        setValue(index);
        switch (index) {
            case 0:
                navigate('/');
                break;
            case 1:
                navigate('/products');
                break;
            case 2:
                navigate('/myaccount');
                break;
            default:
                break;
        }
    };

    return (
        <Paper
            elevation={3}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1200,
                display: { xs: 'block', sm: 'block', md: 'none' }, 
                // backgroundImage: 'radial-gradient(#fff, #ffd6d6)',
                backgroundColor: '#fce8e8ff', // fallback for older browsers
                boxShadow: '0 -5px 5px rgba(0,0,0,0.1)',
            }}
        >
            <BottomNavigation
                showLabels
                value={value}
                onChange={(event, newValue) => handleNavigation(newValue)}
                sx={{
                    backgroundColor: 'transparent',
                    '& .Mui-selected': {
                        color: '#ff4d4d', // highlight color for selected tab
                    },
                }}
            >
                <BottomNavigationAction
                    label="Home"
                    icon={<Home sx={{ color: value === 0 ? '#ff4d4d' : 'gray' }} />}
                    sx={{ '&:hover': { color: '#ff4d4d' } }}
                />
                <BottomNavigationAction


                    label="Products"
                    icon={<CategoryIcon sx={{ color: value === 1 ? '#ff4d4d' : 'gray' }} />}
                    sx={{ '&:hover': { color: '#ff4d4d' } }}
                />
                <BottomNavigationAction
                    label="Account"
                    icon={<Person sx={{ color: value === 2 ? '#ff4d4d' : 'gray' }} />}
                    sx={{ '&:hover': { color: '#ff4d4d' } }}
                />
            </BottomNavigation>
        </Paper>
    );
}

export default MobileBottomNav;
